import { put, call, takeLatest } from "redux-saga/effects";
import axios from "axios";
import API_ENDPOINTS from "@services/apiConfig";

export const actionTypes = {
  getEsignInfo: "agreementEsign/GET_ESIGN_INFO",
  getEsignInfoFailed: "agreementEsign/GET_ESIGN_INFO_FAILED",
  getEsignInfoFulfilled: "agreementEsign/GET_ESIGN_INFO_FULFILLED",

  sendEsignOtp: "agreementEsign/SEND_ESIGN_OTP",
  sendEsignOtpFailed: "agreementEsign/SEND_ESIGN_OTP_FAILED",
  sendEsignOtpFulfilled: "agreementEsign/SEND_ESIGN_OTP_FULFILLED",

  verifyEsignOtp: "agreementEsign/VERIFY_ESIGN_OTP",
  verifyEsignOtpFailed: "agreementEsign/VERIFY_ESIGN_OTP_FAILED",
  verifyEsignOtpFulfilled: "agreementEsign/VERIFY_ESIGN_OTP_FULFILLED",

  resetState: "agreementEsign/RESET_STATE",
};

const initialState = {
  info: {
    fetching: false,
    fetched: false,
    data: null,
    errMsg: null
  },
  EsignOtp: {
    sending: false,
    sent: false,
    errMsg: null
  },
  EsignVerify: {
    verifying: false,
    verified: false,
    data: null,
    errMsg: null
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.getEsignInfo: {
      return {
        ...state,
        info: {
          ...state.info,
          fetching: true,
          errMsg: null
        }
      };
    }
    case actionTypes.getEsignInfoFailed: {
      return {
        ...state,
        info: {
          ...state.info,
          fetching: false,
          fetched: true,
          errMsg: action.payload
        }
      };
    }
    case actionTypes.getEsignInfoFulfilled: {
      return {
        ...state,
        info: {
          ...state.info,
          fetching: false,
          fetched: true,
          data: action.payload,
          errMsg: null
        }
      };
    }

    case actionTypes.sendEsignOtp: {
      return {
        ...state,
        EsignOtp: {
          ...state.EsignOtp,
          sending: true,
          sent: false,
          errMsg: null
        }
      };
    }
    case actionTypes.sendEsignOtpFailed: {
      return {
        ...state,
        EsignOtp: {
          ...state.EsignOtp,
          sending: false,
          sent: false,
          errMsg: action.payload
        }
      };
    }
    case actionTypes.sendEsignOtpFulfilled: {
      return {
        ...state,
        EsignOtp: {
          ...state.EsignOtp,
          sending: false,
          sent: true,
          errMsg: null
        }
      };
    }

    case actionTypes.verifyEsignOtp: {
      return {
        ...state,
        EsignVerify: {
          ...state.EsignVerify,
          verifying: true,
          errMsg: null
        }
      };
    }
    case actionTypes.verifyEsignOtpFailed: {
      return {
        ...state,
        EsignVerify: {
          ...state.EsignVerify,
          verifying: false,
          verified: false,
          errMsg: action.payload
        }
      };
    }
    case actionTypes.verifyEsignOtpFulfilled: {
      return {
        ...state,
        EsignVerify: {
          ...state.EsignVerify,
          verifying: false,
          verified: true,
          data: action.payload,
          errMsg: null
        }
      };
    }

    case actionTypes.resetState:
      return initialState;
    default:
      return state;
  }
};

export const selectors = {
  info: (state) => state.partnerApp?.agreementEsign?.info || {},
  sendOtp: (state) => state.partnerApp?.agreementEsign?.EsignOtp || {},
  verifyOtp: (state) => state.partnerApp?.agreementEsign?.EsignVerify || {},
};

export const actions = {
  getEsignInfo: (einfo) => ({
    type: actionTypes.getEsignInfo,
    payload: einfo,
  }),
  getEsignInfoFailed: (errMsg) => ({
    type: actionTypes.getEsignInfoFailed,
    payload: errMsg,
  }),
  getEsignInfoFulfilled: (data) => ({
    type: actionTypes.getEsignInfoFulfilled,
    payload: data,
  }),

  sendEsignOtp: (data) => ({
    type: actionTypes.sendEsignOtp,
    payload: data,
  }),
  sendEsignOtpFailed: (errMsg) => ({
    type: actionTypes.sendEsignOtpFailed,
    payload: errMsg,
  }),
  sendEsignOtpFulfilled: () => ({
    type: actionTypes.sendEsignOtpFulfilled
  }),

  verifyEsignOtp: (data) => ({
    type: actionTypes.verifyEsignOtp,
    payload: data,
  }),
  verifyEsignOtpFailed: (errMsg) => ({
    type: actionTypes.verifyEsignOtpFailed,
    payload: errMsg,
  }),
  verifyEsignOtpFulfilled: (data) => ({
    type: actionTypes.verifyEsignOtpFulfilled,
    payload: data,
  }),

  resetState: () => ({
    type: actionTypes.resetState
  }),
};

function* getEsignInfoWorker(action) {
  const { merchantUuid, merchant_access_token, merchant_token_type } = action.payload;
  try {
    const response = yield call(
      [axios, "get"],
      API_ENDPOINTS.HOSTED_ESIGN.GET_ESIGN_INFO(merchantUuid),
      {
        headers: {
          Authorization: `${merchant_token_type} ${merchant_access_token}`
        }
      }
    );
    if(response.status === 200){
      yield put(actions.getEsignInfoFulfilled(response?.data));
    }
  } catch (err) {
    yield put(actions.getEsignInfoFailed(err?.response?.data?.message || "Failed to Fetch E-sign Info. Try Again!"));
  }
}

function* sendEsignOtpWorker(action) {
  const { merchantUuid, merchant_access_token, merchant_token_type, signatory_email, send_otp_for_esign, oauth_consent, service_agreement_uuid } = action.payload;
  try {
    const response = yield call(
      [axios, "post"],
      API_ENDPOINTS.HOSTED_ESIGN.SEND_ESIGN_OTP(merchantUuid),
      {
        signatory_email: signatory_email || "",
        send_otp_for_esign: send_otp_for_esign,
        oauth_consent: oauth_consent,
        service_agreement_uuid: service_agreement_uuid || "",
      },
      {
        headers: {
          Authorization: `${merchant_token_type} ${merchant_access_token}`
        }
      }
    );
    if(response.status === 200){
      yield put(actions.sendEsignOtpFulfilled());
    }
  } catch (err) {
    yield put(actions.sendEsignOtpFailed(err?.response?.data?.message || "Failed to send OTP. Try Again!"));
  }
}

function* verifyEsignOtpWorker(action) {
  const { merchantUuid, merchant_access_token, merchant_token_type, signatory_email, send_otp_for_esign, oauth_consent, service_agreement_uuid, otp } = action.payload;
  try {
    const response = yield call(
      [axios, "post"],
      API_ENDPOINTS.HOSTED_ESIGN.VERIFY_ESIGN_OTP(merchantUuid),
      {
        signatory_email: signatory_email || "",
        send_otp_for_esign: send_otp_for_esign,
        oauth_consent: oauth_consent,
        service_agreement_uuid: service_agreement_uuid || "",
        otp: String(otp),
      },
      {
        headers: {
          Authorization: `${merchant_token_type} ${merchant_access_token}`
        }
      }
    );
    if(response.status === 200){
      yield put(actions.verifyEsignOtpFulfilled(response?.data));
    }
  } catch (err) {
    yield put(actions.verifyEsignOtpFailed(err?.response?.data?.message || "Failed to verify OTP. Try Again!"));
  }
}

export function* saga() {
  yield takeLatest(actionTypes.getEsignInfo, getEsignInfoWorker);
  yield takeLatest(actionTypes.sendEsignOtp, sendEsignOtpWorker);
  yield takeLatest(actionTypes.verifyEsignOtp, verifyEsignOtpWorker);
}